import { DefaultTheme } from "styled-components";

export const lightTheme: DefaultTheme = {
  basic: "#FFF5FA",
  main: "#F5007E",
  lightGray: "#E1E5EA",
};
